export class VistaClientError extends Error {}
export class ForbiddenError extends VistaClientError {}
export class AuthenticationError extends VistaClientError {}
export class UserInputError extends VistaClientError {}